import * as React from "react";
const SvgCheckBox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <rect width={16} height={16} fill="#3AB489" rx={8} />
    <path
      stroke="#F5F6FB"
      strokeLinecap="round"
      strokeWidth={1.25}
      d="m4.25 8 2.205 2.205a.417.417 0 0 0 .59 0L11.75 5.5"
    />
  </svg>
);
export default SvgCheckBox;
